import { AccountDetailData } from "../../data/accountDetailData";
import { CardData } from "../../data/cardData";
import { ContractData } from "../../data/contractData";
import { ContractsFilters } from "../../data/enums/contractsFilters";
import { ContractsTypes } from "../../data/enums/contractsTypes";
import { Dictionary } from "../../data/types/index";
import { CardModel } from "./cardModel";
import { ContractModel } from "./contractModel";
import { CardsStates } from "../../data/enums/cardsStates";
import { appConfig } from "../../config";
import currencyFilter from "../../filters/currency.filter";
import sumFilter from "../../filters/sum.filter";

/**  Модель сгруппированных договоров. */
export class ContractsModel {
  /**Библиотека счетов, ключ - id счета */
  public AllContracts: Dictionary<ContractModel> = {};
  /**Карточные и текущие счета */
  public Contracts: Array<ContractModel> = [];
  /**Вклады срочные и по востребованию */
  public Deposits: Array<ContractModel> = [];
  /**Кредиты */
  public Credits: Array<ContractModel> = [];

  public HomeContract: ContractModel = new ContractModel();

  /**Cуммы депозитов в разных валютах */
  public DepositsSums: Dictionary<number> = {};

  /** Суммы депозитов в строке */
  get DepositsSumsString(): string {
    let sumString = "";
    Object.keys(this.DepositsSums).forEach(currency => {
      sumString += `${sumFilter(
        this.DepositsSums[currency]
      )} ${currencyFilter(currency)} `;
    });
    return sumString;
  }

  /**Cуммы кредитов в разных валютах */
  public CreditsSums: Dictionary<number> = {};

  /** Суммы кредитов в строке */
  get CreditsSumsString(): string {
    let sumString = "";
    Object.keys(this.CreditsSums).forEach(currency => {
      sumString +=
        sumFilter(this.CreditsSums[currency]) +
        currencyFilter(currency);
    });
    return sumString;
  }

  constructor(contracts: Array<ContractData> | null = null) {
    if (contracts != null) {

      if (process.env.VUE_APP_NAME == 'FINSERV') {
        const arrays: Array<Array<ContractData>> = [[], [], []];

        const currencys = ['RUR', 'EUR', 'USD'];

        contracts.map((contract: ContractData) => {
          const index: number = currencys.indexOf(contract.CurrencyCharCode);
          if (index !== -1) {
            arrays[index].push(contract);
          } else {
            currencys.push(contract.CurrencyCharCode);
            arrays.push([]);
            arrays[arrays.length-1].push(contract);
          }
        });

        arrays.map((array: Array<ContractData>) => {
          array = array.sort((a: ContractData, b: ContractData) => {
            const dateNow: number = new Date().valueOf();
            const dateA: number = a.DateOpen ? a.DateOpen.valueOf() : dateNow;
            const dateB: number = b.DateOpen ? b.DateOpen.valueOf() : dateNow;
            return dateA - dateB;
          })
        });

        //Сортировка счетов по дате, от нового к старому
        const sortedContracts: Array<ContractData> = [];
        
        arrays.map((array: Array<ContractData>) => {
          array.map((item: ContractData) => {
            sortedContracts.push(item);
          })
        });

        const cardContracts: ContractModel[] = [];
        const currContracts: ContractModel[] = [];
        //Группировка счетов.
        sortedContracts.forEach(contract => {
          const tempContract = new ContractModel(contract);
          this.AllContracts[contract.Id.toString()] = tempContract;

          if (
            contract.ContractType == ContractsTypes.CardAccount
          ) {
            cardContracts.push(tempContract);
          } else if (contract.ContractType == ContractsTypes.CurrentAccount) {
            currContracts.push(tempContract);
          } else if (
            contract.ContractType == ContractsTypes.DepositAccounts ||
            contract.ContractType == ContractsTypes.TimeAccounts
          ) {
            this.Deposits.push(tempContract);
          } else {
            this.Credits.push(tempContract);
          }
        });

        cardContracts.map((contract: ContractModel) => {
          this.Contracts.push(contract);
        });

        currContracts.map((contract: ContractModel) => {
          this.Contracts.push(contract);
        });
      } else {
        const sortedContracts = contracts.sort((a: ContractData, b: ContractData) => {
          const dateNow: number = new Date().valueOf();
          const dateA: number = a.DateOpen ? a.DateOpen.valueOf() : dateNow;
          const dateB: number = b.DateOpen ? b.DateOpen.valueOf() : dateNow;
          return dateB - dateA;
        })

        const cardAndCurrContracts: ContractModel[] = []
        //Группировка счетов.
        sortedContracts.forEach(contract => {
          const tempContract = new ContractModel(contract);
          this.AllContracts[contract.Id.toString()] = tempContract;

          if (
            contract.ContractType == ContractsTypes.CardAccount ||
            contract.ContractType == ContractsTypes.CurrentAccount ||
            contract.ContractType == ContractsTypes.None
          ) {
            cardAndCurrContracts.push(tempContract);
          } else if (
            contract.ContractType == ContractsTypes.DepositAccounts ||
            contract.ContractType == ContractsTypes.TimeAccounts
          ) {
            this.DepositsSums[contract.CurrencyCharCode] = this.DepositsSums[
              contract.CurrencyCharCode
            ]
              ? this.DepositsSums[contract.CurrencyCharCode] +
              contract.DisposableLimit
              : contract.DisposableLimit;
            this.Deposits.push(tempContract);
          } else {
            this.CreditsSums[contract.CurrencyCharCode] = this.CreditsSums[
              contract.CurrencyCharCode
            ]
              ? this.CreditsSums[contract.CurrencyCharCode] +
              contract.DisposableLimit
              : contract.DisposableLimit;
            this.Credits.push(tempContract);
          }
        });

        this.Contracts = cardAndCurrContracts.sort((a: ContractModel, b: ContractModel) => {
          return b.Data.ContractType - a.Data.ContractType
        })
      }

      // this.Contracts = cardAndCurrContracts.sort(
      //   (a: ContractModel, b: ContractModel) => {
      //     return b.Data.ContractType - a.Data.ContractType;
      //   }
      // );
    }
  }

  /**
   * Обновить данные счёта
   * @param contract Новые данные
   * @param bankDetails Реквизиты счета
   */
  public updateContract(contract: ContractData): void {
    if (this.AllContracts && this.AllContracts[contract.Id.toString()]) {
      this.AllContracts[contract.Id.toString()].update(contract);
    }
  }

  /**
   * Обновить данные счёта
   * @param id Идентификатор счета
   * @param bankDetails Реквизиты счета
   */
  public updateAccountDetails(
    id: number,
    bankDetails: AccountDetailData
  ): void {
    if (this.AllContracts && this.AllContracts[id.toString()]) {
      this.AllContracts[id.toString()].BankDetails = bankDetails;
    }
  }

  /**
   * Обновить данные карты
   * @param card Новые данные
   * @param contractId Идентификатор счета
   */
  public updateCard(card: CardData, contractId: number): void {
    const existCard = this.getCard(contractId, card.Id);
    if (existCard) existCard.Data.update(card);
  }

  /**
   * Получение информации по счету по ИД
   * @param id Идентификатор счета в ДБО
   */
  public getContract(id: number): ContractModel {
    return this.AllContracts[id.toString()];
  }

  /**
   * Получение информации по счету по ИД
   * @param id Идентификатор счета в ДБО
   */
  public getContractByRefId(refId: string): ContractModel | null {
    for (const key in this.AllContracts) {
      if (this.AllContracts[key].Data.ReferenceId == refId)
        return this.AllContracts[key];
    }
    return null;
  }

  /**
   * Получение информации по карте
   * @param contractId Идентификатор счета в ДБО
   * @param cardId Идентификатор карты в ДБО
   */
  public getCard(сontractId: number, cardId: number): CardModel {
    const contract: ContractModel = this.AllContracts[сontractId.toString()];
    let cardModel: CardModel = new CardModel();

    if (contract) {
      cardModel = contract.Cards.find((c: CardModel) => {
        return c.Data.Id == cardId;
      });
    }
    return cardModel;
  }

  public getActiveCard(): CardModel {
    let activeCard: CardModel = null;
    this.Contracts.forEach((contract: ContractModel) => {
      if (!activeCard) {
        activeCard = contract.Cards.find((card: CardModel) => card.Data.CardState === CardsStates.Active);
        if (activeCard)
          this.HomeContract = contract;
      }
    });
    if (!activeCard && this.Contracts.length > 0) {
      this.HomeContract = this.Contracts.find((contract: ContractModel) => contract.Data.Id);
    } else if (!activeCard && this.Deposits.length > 0) {
      this.HomeContract = this.Deposits.find((contract: ContractModel) => contract.Data.Id);
    } else if (!activeCard && this.Credits.length > 0) {
      this.HomeContract = this.Credits.find((contract: ContractModel) => contract.Data.Id);
    }
    return activeCard;
  }

  /**
   * Получение списка счетов по фильтру
   * @param filter Фильтр счетов
   * @param showHiddenContracts Добавлять скрытые счета в список
   * @param showOnlyWithPositiveRest Показывать счета только с положительным остатком
   */
  public getContractsByFilter(
    filter: ContractsFilters = ContractsFilters.None,
    showHiddenContracts = false,
    showOnlyWithPositiveRest = false
  ): Array<ContractModel> {
    const filtredContracts: Array<ContractModel> = [];
    if (filter == (1 as ContractsFilters))
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.StateClosed |
          ContractsFilters.WithdrawDisable |
        (appConfig.timeAccountEnableForFilter1 ? 0 : (ContractsFilters.TypeTime |
          ContractsFilters.TypeDeposit)) |
          ContractsFilters.CurrencyOthers
        );
    //отключаем закрытые и с запретом списания и срочные и до востр. и валютные
    else if (filter == (3453 as ContractsFilters))
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.StateClosed |
          ContractsFilters.WithdrawDisable |
          ContractsFilters.TypeTime |
          ContractsFilters.TypeCard |
          ContractsFilters.CurrencyOthers
        );
    //отключаем закрытые и с запретом списания и срочные и карточные
    else if (filter == (2 as ContractsFilters))
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.StateClosed |
          ContractsFilters.DepositDisable |
          ContractsFilters.CurrencyOthers
        );
    //отключаем закрытые и с запретом пополнения  и валютные (5+'срочные')
    else if (filter == (3 as ContractsFilters))
      //"1"+срочные
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.StateClosed |
          ContractsFilters.WithdrawDisable |
          ContractsFilters.CurrencyOthers
        );
    //отключаем закрытые и с запретом списания
    else if (filter == (4 as ContractsFilters))
      //все открытые
      filter =
        ContractsFilters.All &
        ~(ContractsFilters.StateClosed | ContractsFilters.CurrencyOthers);
    //отключаем закрытые
    else if (filter == (5 as ContractsFilters))
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.StateClosed |
          ContractsFilters.DepositDisable |
          ContractsFilters.TypeTime |
          ContractsFilters.TypeCredit |
          ContractsFilters.CurrencyOthers
        );
    //отключаем закрытые и с запретом пополнения и срочные
    else if (filter == (6 as ContractsFilters))
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.TypeTime |
          ContractsFilters.TypeDeposit |
          ContractsFilters.TypeCurrent |
          ContractsFilters.TypeCard |
          ContractsFilters.StateClosed
        );
    //открытые кредиты
    else if (filter == (7 as ContractsFilters))
      //1+CurrencyOthers
      filter =
        ContractsFilters.All &
        ~(
          ContractsFilters.StateClosed |
          ContractsFilters.WithdrawDisable |
          (appConfig.timeAccountEnableForFilter7 ? 0 : (ContractsFilters.TypeTime |
            ContractsFilters.TypeDeposit))
        );
    //отключаем закрытые и с запретом списания и срочные и до востр.
    else if (filter == (8 as ContractsFilters))
      //2+CurrencyOthers
      filter =
        ContractsFilters.All &
        ~(ContractsFilters.StateClosed | ContractsFilters.DepositDisable);
    //отключаем закрытые и с запретом пополнения (5+'срочные')
    else if (filter == (9 as ContractsFilters))
      //7+CurrencyOthers
      filter =
        ContractsFilters.All &
        ~(ContractsFilters.StateClosed | ContractsFilters.WithdrawDisable); //отключаем закрытые и с запретом списания (7+'срочные' и 'до востребования')
    else if (filter == (10 as ContractsFilters))
      filter = ContractsFilters.All & ~(ContractsFilters.TypeCredit | ContractsFilters.TypeCurrent | ContractsFilters.TypeDeposit | ContractsFilters.TypeTime);

    if (!this.AllContracts) return filtredContracts;

    for (const key in this.AllContracts) {
      const contract = this.AllContracts[key];
      const cClosed: boolean = !contract.IsOpen;
      if (
        (cClosed && (filter & ContractsFilters.StateClosed) == 0) ||
        (!cClosed && (filter & ContractsFilters.StateOpened) == 0)
      )
        continue;

      const cType = contract.Data.ContractType;
      if (
        (cType == ContractsTypes.CardAccount &&
          (filter & ContractsFilters.TypeCard) == 0) ||
        (cType == ContractsTypes.CreditAccount &&
          (filter & ContractsFilters.TypeCredit) == 0) ||
        (cType == ContractsTypes.CurrentAccount &&
          (filter & ContractsFilters.TypeCurrent) == 0) ||
        (cType == ContractsTypes.DepositAccounts &&
          (filter & ContractsFilters.TypeDeposit) == 0) ||
        (cType == ContractsTypes.TimeAccounts &&
          (filter & ContractsFilters.TypeTime) == 0)
      )
        continue;

      const cD = contract.Data.CanDeposit;
      if (
        (cD && (filter & ContractsFilters.DepositEnable) == 0) ||
        (!cD && (filter & ContractsFilters.DepositDisable) == 0)
      )
        continue;

      const cW = contract.Data.CanWithdraw;
      if (
        (cW && (filter & ContractsFilters.WithdrawEnable) == 0) ||
        (!cW && (filter & ContractsFilters.WithdrawDisable) == 0)
      )
        continue;

      const rur: boolean = contract.Data.CurrencyCharCode.toLowerCase() == "rur";
      const usd: boolean = contract.Data.CurrencyCharCode.toLowerCase() == "usd";
      const eur: boolean = contract.Data.CurrencyCharCode.toLowerCase() == "eur";
      const cny: boolean = contract.Data.CurrencyCharCode.toLowerCase() == "cny";
      const chf: boolean = contract.Data.CurrencyCharCode.toLowerCase() == "chf";
      if (!rur && (filter & ContractsFilters.CurrencyOthers) == 0
        || rur && (filter & ContractsFilters.CurrencyMain) == 0 
        || usd && (filter & ContractsFilters.CurrencyUsd) == 0
        || eur && (filter & ContractsFilters.CurrencyEur) == 0
        || cny && (filter & ContractsFilters.CurrencyCny) == 0
        || chf && (filter & ContractsFilters.CurrencyChf) == 0
      )
        continue;

      if (contract.Data.Hidden && !showHiddenContracts) continue;

      if (contract.Data.DisposableLimit <= 0 && showOnlyWithPositiveRest)
        continue;

      filtredContracts.push(contract);
    }

    return filtredContracts;
  }

  get isEmpty(): boolean {
    return (
      this.Contracts.length == 0 &&
      this.Deposits.length == 0 &&
      this.Credits.length == 0
    );
  }
  /**
* Получение списка счетов для входящих операций СБП
* @param filter Фильтр счетов
*/
  public getSbpInContracts(): Array<ContractModel> {
    const filter = ContractsFilters.CurrencyMain
      | ContractsFilters.DepositEnable
      | ContractsFilters.WithdrawAll
      | ContractsFilters.TypeCard
      | ContractsFilters.StateOpened;
    return this.getContractsByFilter(filter);
  }
}
